<template>
  <div class="element-input element-textbox" :class="{ disabled }">
    <div class="label">{{ label }}</div>
    <div class="body">
      <input @input="search" :readonly="readonly" :type="inputType" v-model="model" :disabled="disabled" :placeholder="placeholder" />
      <span class="input-password-icon" v-if="type && togglePassword">
        <i v-if="visible" class="far fa-eye" @click="togglePasswordType"></i>
        <i v-if="!visible" class="far fa-eye-slash" @click="togglePasswordType"></i>
      </span> 
    </div>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "disabled", "placeholder", "readonly", "type", "togglePassword" ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  data () {
    return {
      inputType: 'text',
      visible: false,
    }
  },
  created () {
    if(this.type == undefined) this.$emit( "type", "text" )
    if(this.type) this.inputType = this.type
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    },
    search(e) {
      if(e.target.value.length > 0)
        this.$emit('search', e.target.value)
    },
    togglePasswordType() {
      this.visible = !this.visible
      if(this.visible)
        this.inputType = "text"
      else
        this.inputType = "password"
    }
  }

}
</script>
